import React, { Component } from "react";
import "./index.css";
import BsySwitchBtn from "../../BsySwitchBtn";
import BsyRadioGroup from "../../BsyRadioGroup";
import type1 from "../../../images/dashboard/noticeBoard1.png";
import type2 from "../../../images/dashboard/noticeBoard2.png";
import type3 from "../../../images/dashboard/noticeBoard3.png";
import classNames from "classnames";
import BsyMsgBubble from '../../../components/BsyMsgBubble';
import BsyDialog from "../../../components/BsyDialog";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import AlertListSelectAppPopupPane from "../../../components/BsyAlertListDetail/selectAppPopupPane";
import ConfigurationBulletinConfig from "./configurationBulletinConfig"
import BsyConfigurationBulletinStaicConfig from "./ConfigurationBulletinStaticConfig"
import { BsyUtils } from "../../../utils/Utils";
import BsyAlert from "../../BsyAlert";
import _ from 'lodash';
import noType from "../../../images/dashboard/img_notice.png";
class BsyDashboardNoticeBoardConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMoreType: props.noticeBoard.showMoreType || false,
      isShowTitle: props.noticeBoard.isShowTitle || false, //显示标题
      titleName: props.noticeBoard.titleName || "公告栏",
      isShowMoreTitle: props.noticeBoard.isShowMoreTitle || false,//查看更多
      styleType: props.noticeBoard.styleType || "", //样式
      titleLinkType: props.noticeBoard.titleLinkType || "internalPage", //'externalLink' //标题链接类型
      titleModelink: props.noticeBoard.titleModelink || "",
      titleModelFromData: props.noticeBoard.titleModelFromData || {}, //内部页面返回值
      imgModelFromData: props.noticeBoard.imgModelFromData || {},
      dataSource: props.noticeBoard.dataSource || "dynamicDataSource", //staticDataSource 公告内容数据来源
      noticeListDynamic: props.noticeBoard.noticeListDynamic || [],  // 公告内容动态数据来源
      noticeListStatic: props.noticeBoard.noticeListStatic || [],  // 公告内容静态数据来源
      imgFile: props.noticeBoard.imgFile || {},
      coverStyle: props.noticeBoard.coverStyle || "fillInCenter",
      imgLinkType: props.noticeBoard.imgLinkType || "internalPage", //'externalLink'
      dataSourceDynamicChoose: props.noticeBoard.dataSourceDynamicChoose || {},
      dynamicDialogObj: props.noticeBoard.dynamicDialogObj || {},//动态弹窗配置数据
      isShowSetDynamicPage: false,
      isShowSetStaticPage: false,
      staticIndex: 0,
      staticData: {},
      isSaveEvent: true
    };
    this.theImgModelink = props.noticeBoard.imgModelink || "";  //用户输入值,保存的时候再拼接
    this.theTitleModelink = props.noticeBoard.titleModelink || "";  //用户输入值,保存的时候再拼接
    this.theTitleModelFromData = props.noticeBoard.titleModelFromData || {} //用于接收返回值 
    this.theImgModelFromData = props.noticeBoard.imgModelFromData || {} //用于接收返回值

  }
  changeType = (type) => {
    this.setState({
      styleType: type,
    });
  };
  changeMoreType = () => {
    let type = this.state.showMoreType;
    this.setState({
      showMoreType: !type,
    });
  };
  changeTitle = () => {
    let isShowTitle = this.state.isShowTitle;
    this.setState({
      isShowTitle: !isShowTitle,
    });
  };
  inputTitle = (event) => {
    this.setState({
      titleName: event.target.value.slice(0, 20)
    })
  }
  changeMore = () => {
    let isShowMoreTitle = this.state.isShowMoreTitle;

    this.setState({
      isShowMoreTitle: !isShowMoreTitle,
    }, () => {
      this.checkSaveStateFn()
    });
  };
  getTitlePopupValue = (ref) => {
    if (!_.isEmpty(ref.appinfo)) {
      this.theTitleModelFromData = ref
    }
  };
  getImgPopupValue = (ref) => {
    if (!_.isEmpty(ref.appinfo)) {
      this.theImgModelFromData = ref
    }
  }
  hoverEnterPanel = (event) => {
    BsyMsgBubble({
      anchor: event.currentTarget,
      dockPosition: "center",
      text4Ok: null,
      width: 280,
      text4Cancel: null,
      edge: 50,
      // hAdjust: add(item.text) / 3,
      contentHTML: () => {
        return (<div className='t-notice-tip-quiker'>配置样式一和样式三最多展示6条，样式二最多展示3条，其他更多数据展示在【查看更多】页面</div>)
      },
    });
  }
  hoverLeavePanel = () => {
    window.$('.bsy-msg-bubble').remove()
  }
  deleteTitleModelFromDataFn = (event) => {
    event.stopPropagation()
    this.theTitleModelFromData = {}
    this.setState({
      titleModelFromData: {},
    }, () => {
      this.checkSaveStateFn()
    });

  }
  chooseTitlelinkType = () => {
    BsyDialog({
      title: React.language("form.select"),
      height: 540,
      width: 720,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return (
          <AlertListSelectAppPopupPane
            showTypeList={['dash']}
            noHome={true}
            appid={this.state.titleModelFromData.appid}
            formid={this.state.titleModelFromData.formid}
            getValue={this.getTitlePopupValue}
          />
        );
      },
      onOk: () => {
        this.setState({
          titleModelFromData: this.theTitleModelFromData
        }, () => {
          this.checkSaveStateFn()
        })
      }
    });
  }
  deleteImgModelFromDataFn = (event) => {
    event.stopPropagation()
    this.theImgModelFromData = {}
    this.setState({
      imgModelFromData: {},
    });
  }
  chooselinkImgType = () => {
    BsyDialog({
      title: React.language("form.select"),
      height: 540,
      width: 720,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return (
          <AlertListSelectAppPopupPane
            showTypeList={['dash']}
            noHome={true}
            appid={this.state.imgModelFromData.appid}
            formid={this.state.imgModelFromData.formid}
            getValue={this.getImgPopupValue}
          />
        );
      },
      onOk: () => {
        this.setState({
          imgModelFromData: this.theImgModelFromData
        })
      }
    });
  }
  setStaticDataSource = (item, key) => {
    this.staticData = item
    this.staticIndex = key
    this.setState({
      isShowSetStaticPage: true,
      isSaveEvent: false
    })
  }
  deleteStaticDataSource = (key) => {
    let noticeListStatic = this.state.noticeListStatic
    noticeListStatic.splice(key, 1)
    this.setState({
      noticeListStatic: noticeListStatic
    })
  }
  deleteDynamicDataSource = (key) => {
    let noticeListDynamic = this.state.noticeListDynamic
    noticeListDynamic.splice(key, 1)
    this.setState({
      noticeListDynamic: noticeListDynamic
    })
  }

  configurationBulletin = () => {

    if (this.state.dataSource === 'staticDataSource') {
      let list = this.state.noticeListStatic
      list.push({
        title: React.language("workbench.noticeBoard.add.title") + (list.length + 1),
        date: parseInt(new Date().getTime()),
        link: '',
        interModel: {},
        linkType: 'externalLink' //internalPage
      })
      this.setState({
        noticeListStatic: list
      })
    } else {

      this.setState({
        isShowSetDynamicPage: true,
        isSaveEvent: false
      })
      window.$('.config-right-content').scrollTop(0)
    }

  }

  closePan = () => {
    this.props.emitClosePan()
  };
  savePan = () => {
    this.props.getNoticeSlideContext && this.props.getNoticeSlideContext.onRemoveRoot && this.props.getNoticeSlideContext.onRemoveRoot();
    this.props.emitSaveBoardNotice(this.reseveoticeBoard())
  };
  reseveoticeBoard = () => {
    let noticeBoard = {
      showMoreType: this.state.showMoreType,
      titleName: this.state.titleName,
      isShowTitle: this.state.isShowTitle,
      isShowMoreTitle: this.state.isShowMoreTitle,
      styleType: this.state.styleType,
      titleLinkType: this.state.titleLinkType,
      titleModelFromData: this.state.titleModelFromData,
      titleModelink: this.theTitleModelink,
      dataSource: this.state.dataSource,
      dataSourceDynamicChoose: this.state.dataSourceDynamicChoose,
      noticeListDynamic: this.state.noticeListDynamic,
      noticeListStatic: this.state.noticeListStatic,
      imgFile: this.state.imgFile,
      coverStyle: this.state.coverStyle,
      imgLinkType: this.state.imgLinkType,
      imgModelFromData: this.state.imgModelFromData,
      imgModelink: this.theImgModelink,
      dynamicDialogObj: this.state.dynamicDialogObj,
      enable: this.props.noticeBoard.enable,
      seq: this.props.noticeBoard.seq,
      gridW:this.props.block.w
    }
    return noticeBoard
  }
  approveTitleChange = () => { };

  linkTitleEdit = (event) => {
    this.theTitleModelink = event.target.value;
    this.setState({
      titleModelink: event.target.value
    }, () => {
      this.checkSaveStateFn()
    })
  };
  linkImgEdit = (event) => {
    this.theImgModelink = event.target.value;
  }
  changeImg = (event) => {
    let _this = this;
    const selectedFile = Array.from(event.target.files);
    const maxSize = window.FX.STATIC.VIP_PACK.single_file;
    if (selectedFile[0].size >= maxSize) {
      tipAlert({
        msg: React.language("image.upload.size.rules.one", { count: window.FX.STATIC.VIP_PACK.single_file / 1024 / 1024 }),
        type: "warning",
      });
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile[0]);
    formData.append(
      "x:uploader",
      window.FX.STATIC.user ? window.FX.STATIC.user._id : ""
    );
    React.axios("/dashboard/upload_workbenches_img", formData)
      .then((res) => {
        _this.setState({
          imgFile: res.data.file,
        });
      })
      .catch((err) => {
        tipAlert({
          type: "warning",
          msg: err,
        });
      })
      .finally(() => { });
  };
  deleteImg = () => {
    this.setState({
      imgFile: {}
    });
  }
  emitDynamicComplete = (data, dataSourceDynamicChoose, type, source) => {
    if (type === 'close') {
      this.setState({
        isShowSetDynamicPage: false,
        dynamicDialogObj: source,
        isSaveEvent: true
      })
      return
    }
    this.setState({
      isShowSetDynamicPage: false,
      noticeListDynamic: data,
      dataSourceDynamicChoose: dataSourceDynamicChoose,
      dynamicDialogObj: source,
      isSaveEvent: true
    })
  }
  emitStaciComplete = (item) => {
    let noticeListStatic = this.state.noticeListStatic
    noticeListStatic[this.staticIndex] = item
    this.setState({
      isShowSetStaticPage: false,
      noticeListStatic: noticeListStatic,
      isSaveEvent: true
    })
  }
  getListData = (data) => {
    let list = []
    if (this.state.styleType === 'two') {
      list = data.filter((item, key) => {
        return key <= 2
      })
    } else {
      list = data
    }
    if (list.length === 0) {
      return <div className="no-data"><span>无配置数据</span></div>
    }
    return <>
      {
        list.map((item, key) => {
          return <li key={key}>
            <div className="left-noot">
              <i className="icon-dian"></i>
              <span className="title">{item.title || item.link}</span>
            </div>
            <div className="time">{item.date && BsyUtils.date2Str(new Date(item.date), "yyyy-MM-dd")}</div>
          </li>
        })
      }

    </>

  }
  checkSaveStateFn = () => {
    if (this.state.isShowMoreTitle) {
      if (this.state.titleLinkType === "internalPage" && _.isEmpty(this.state.titleModelFromData)) {
        this.setState({
          isSaveEvent: false
        })
      } else if (this.state.titleLinkType === "externalLink" && _.isEmpty(this.state.titleModelink)) {
        this.setState({
          isSaveEvent: false
        })
      } else {
        this.setState({
          isSaveEvent: true
        })
      }
      return true
    } else {
      this.setState({
        isSaveEvent: true
      })
    }
  }
  render() {
    // (!(this.state.isShowMoreTitle && this.state.titleLinkType ==="internalPage" && _.isEmpty(this.state.titleModelFromData)) || !(this.state.isShowMoreTitle && this.state.titleLinkType ==="externalLink" && _.isEmpty(this.state.titleModelink)))
    return (
      <div className="notice-board-config">
        <div className="config-content">
          <div className="config-left-content">
            {this.state.styleType === "one" && (
              <div className="box type-one">
                {
                  (this.state.isShowTitle || this.state.isShowMoreTitle) && <header>
                    <div style={{ height: "24px" }}>
                      {this.state.isShowTitle && (<div className="title">{this.state.titleName}</div>)}
                    </div>
                    {this.state.isShowMoreTitle && (<div className="more">
                      <span>{React.language("dashboard.see.more")}</span>
                      <i className="icon-subform-next"></i>
                    </div>)}
                  </header>
                }

                <div className="content">
                  {
                    _.isEmpty(this.state.imgFile) && <div className="img-bg img-bg-no"></div>
                  }
                  {
                    !_.isEmpty(this.state.imgFile) && <div className={classNames("img-bg", this.state.coverStyle)} style={{
                      backgroundImage: this.state.imgFile.previewUrl
                        ? "url(" + this.state.imgFile.previewUrl + ")"
                        : window.FX.CONFIG.HOST.IMAGE_HOST + "/" + this.state.imgFile.qnKey,
                    }}></div>
                  }
                  <ul>
                    {this.state.dataSource === "dynamicDataSource" && this.getListData(this.state.noticeListDynamic)}
                    {this.state.dataSource === "staticDataSource" && this.getListData(this.state.noticeListStatic)}
                  </ul>
                </div>
              </div>
            )}
            {this.state.styleType === "two" && (
              <div className="box type-two">
                {
                  (this.state.isShowTitle || this.state.isShowMoreTitle) && <header>
                    <div className="title-box">
                      {this.state.isShowTitle && (<div className="title">{this.state.titleName}</div>)}
                    </div>
                    {this.state.isShowMoreTitle && (
                      <div className="more">
                        <span>{React.language("dashboard.see.more")}</span>
                        <i className="icon-subform-next"></i>
                      </div>
                    )}
                  </header>
                }

                <div className="content">
                  {
                    _.isEmpty(this.state.imgFile) && <div className="img-bg img-bg-no"></div>
                  }
                  {
                    !_.isEmpty(this.state.imgFile) && <div className={classNames("img-bg", this.state.coverStyle)} style={{
                      backgroundImage: this.state.imgFile.previewUrl
                        ? "url(" + this.state.imgFile.previewUrl + ")"
                        : window.FX.CONFIG.HOST.IMAGE_HOST + "/" + this.state.imgFile.qnKey,
                    }}></div>
                  }
                  <ul>
                    {this.state.dataSource === "dynamicDataSource" && this.getListData(this.state.noticeListDynamic)}
                    {this.state.dataSource === "staticDataSource" && this.getListData(this.state.noticeListStatic)}
                  </ul>
                </div>
              </div>
            )}
            {this.state.styleType === "three" && (
              <div className="box type-three">
                {
                  (this.state.isShowTitle || this.state.isShowMoreTitle) && <header>
                    <div className="title-box">
                      {this.state.isShowTitle && (<div className="title">{this.state.titleName}</div>)}
                    </div>
                    {this.state.isShowMoreTitle && (
                      <div className="more">
                        <span>{React.language("dashboard.see.more")}</span>
                        <i className="icon-subform-next"></i>
                      </div>
                    )}
                  </header>
                }

                <div className="content">
                  {
                    _.isEmpty(this.state.imgFile) && <div className="img-bg img-bg-no"></div>
                  }
                  {
                    !_.isEmpty(this.state.imgFile) && <div className={classNames("img-bg", this.state.coverStyle)} style={{
                      backgroundImage: this.state.imgFile.previewUrl
                        ? "url(" + this.state.imgFile.previewUrl + ")"
                        : window.FX.CONFIG.HOST.IMAGE_HOST + "/" + this.state.imgFile.qnKey,
                    }}></div>
                  }
                  <ul>
                    {this.state.dataSource === "dynamicDataSource" && this.getListData(this.state.noticeListDynamic)}
                    {this.state.dataSource === "staticDataSource" && this.getListData(this.state.noticeListStatic)}
                  </ul>
                </div>
              </div>
            )}
            {
              this.state.styleType === "" && (<div className="no-styleType-box"><div className="no-styleType"><img alt="" src={noType} /><div className="tip">请在右侧属性中设置公告栏</div></div></div>)
            }
          </div>
          <div className="config-right-content">
            {
              (!this.state.isShowSetDynamicPage && !this.state.isShowSetStaticPage) && <> <div className="header-type">
                <div className="title">{React.language("form.theme.style")}</div>
                <div
                  className={classNames(this.state.styleType === "one" ? "active" : "") + " type-cla"}
                  onClick={() => { this.changeType("one"); }}
                >
                  <img src={type1} alt="" />
                </div>
                {this.state.showMoreType && (
                  <>
                    <div
                      className={classNames(this.state.styleType === "two" ? "active" : "") + " type-cla"
                      }
                      onClick={() => {
                        this.changeType("two");
                      }}
                    >
                      <img src={type2} alt="" />
                    </div>
                    <div
                      className={classNames(this.state.styleType === "three" ? "active" : "") + " type-cla"}
                      onClick={() => {
                        this.changeType("three");
                      }}
                    >
                      <img src={type3} alt="" />
                    </div>
                  </>
                )}
                <div
                  className="more-btn"
                  onClick={() => {
                    this.changeMoreType();
                  }}
                >
                  <span>{React.language("workbench.noticeBoard.thare.style")}</span>
                  <i className={classNames(this.state.showMoreType ? "active" : "") + " icon-up1"}></i>
                </div>
              </div>
                {
                  this.state.styleType !== "" && <>
                    <div className="title-col">
                      <div className="title">{React.language("workbench.noticeBoard.title")}</div>
                      <div className="box">
                        <div className="text">{React.language("show.title")}</div>
                        <div className="Audit">
                          <BsySwitchBtn
                            power={this.state.isShowTitle}
                            switchChange={this.changeTitle}
                          />
                        </div>
                      </div>
                      {
                        this.state.isShowTitle && <div className="title-box">
                          <input placeholder="请输入标题" className={classNames(this.state.titleName.length > 20 ? "active" : "")} value={this.state.titleName || ""}
                            onInput={(event) => {
                              this.inputTitle(event);
                            }} />
                        </div>
                      }
                      <div className="box">
                        <div className="text">
                          {React.language("dashboard.see.more")}
                        </div>
                        <div className="Audit">
                          <BsySwitchBtn
                            power={this.state.isShowMoreTitle}
                            switchChange={this.changeMore}
                          />
                        </div>
                      </div>
                      {this.state.isShowMoreTitle && <div className="link-type">
                        <div className="text">
                          <i style={{ color: "var(--bsy-base-error-color)" }}>*</i>{React.language("dashboard.link.type")}
                        </div>
                        <div className="radio-box">
                          <BsyRadioGroup layout={"horizontal"} value={this.state.titleLinkType}
                            items={[
                              {
                                value: "internalPage",
                                text: React.language("dashboard.open.internal.page"),
                              },
                              {
                                value: "externalLink",
                                text: React.language("dashboard.open.external.link"),
                              },
                            ]}
                            onStopEdit={(e) => {
                              this.setState({
                                titleLinkType: e,
                              }, () => { this.checkSaveStateFn() });

                            }}
                          />
                        </div>
                        {this.state.titleLinkType === "internalPage" && (
                          <div className={classNames(_.isEmpty(this.state.titleModelFromData) ? "choose-type has-up" : "choose-type has-close")} onClick={() => {
                            this.chooseTitlelinkType()
                          }}>
                            {
                              _.isEmpty(this.state.titleModelFromData) && <span className="place-holder-title">请选择表单</span>
                            }
                            {
                              !_.isEmpty(this.state.titleModelFromData) && <div className="has-icon">
                                <span className={"parent-icon color-cover-" + this.state.titleModelFromData.appinfo.style.color} >
                                  <span className={"imgbg-bby-app imgbg-bby-app-" + (this.state.titleModelFromData.appinfo.style.icon)}></span>
                                </span>
                                <span>{this.state.titleModelFromData.appinfo.appname}</span>
                                <span className="line">—</span>
                                {/* <i className={"icon-bsy-form "+this.state.titleModelFromData.appinfo.style.newIcon?"icon-new-bsy-form-"+this.state.titleModelFromData.appinfo.style.newIcon:"icon-bsy-form-"+this.state.titleModelFromData.icon}></i> */}
                                <span>{this.state.titleModelFromData.name}</span>
                              </div>
                            }
                            <i className="icon-down1"></i>
                            <i className="icon-dingding-guide-close close" onClick={this.deleteTitleModelFromDataFn}></i>
                          </div>
                        )}
                        {this.state.titleLinkType === "externalLink" && (
                          <div className="input-box">
                            <input type="text" className="t-input" placeholder="请输入链接" defaultValue={this.theTitleModelink}
                              onInput={(event) => {
                                this.linkTitleEdit(event);
                              }}
                            ></input>
                          </div>
                        )}
                      </div>}
                    </div>
                    <div className="notice-content">
                      <div className="title">
                        <span>{React.language("workbench.noticeBoard.dataSource")}</span>
                        <i className='icon-bsy-help'
                          onMouseEnter={(event) => {
                            this.hoverEnterPanel(event)
                          }} onMouseLeave={(event) => {
                            this.hoverLeavePanel(event)
                          }}></i>
                      </div>
                      <div className="text">
                        <span>{React.language("dataSource")}</span>
                      </div>
                      <div className="radio-box">
                        <BsyRadioGroup layout={"horizontal"} value={this.state.dataSource}
                          items={[
                            {
                              value: "dynamicDataSource",
                              text: React.language("dashboard.dynamic.data.source"),
                            },
                            {
                              value: "staticDataSource",
                              text: React.language("dashboard.Static.data.source"),
                            },
                          ]}
                          onStopEdit={(e) => {
                            this.setState({
                              dataSource: e,
                            });
                          }}
                        />
                      </div>
                      <ul className="ul-list">
                        {
                          this.state.dataSource === 'staticDataSource' && this.state.noticeListStatic.map((item, key) => {
                            return <li key={key}>
                              <div className="input-box" onClick={() => {
                                this.setStaticDataSource(item, key)
                              }}>
                                {item.title}
                              </div>
                              <div className="set-btn" onClick={() => {
                                this.setStaticDataSource(item, key)
                              }}><i className="icon-bsy-form-21"></i></div>
                              <div className="delete-btn" onClick={() => {
                                this.deleteStaticDataSource(key)
                              }}>
                                <i className="icon-bsy-iconshanchu"></i>
                              </div>
                            </li>
                          })
                        }

                      </ul>
                      <div className={classNames((this.state.noticeListStatic.length >= 6 && this.state.dataSource === "staticDataSource") ? "no-event" : "")}>
                        <div className="btn" onClick={() => {
                          this.configurationBulletin()
                        }}>
                          {
                            this.state.dataSource === 'dynamicDataSource' ? (<span>{React.language("workbench.noticeBoard.setting")}</span>) :
                              (<>
                                <span>{React.language("workbench.noticeBoard.add")}</span>
                              </>)}
                        </div>
                      </div>

                    </div>
                    <div className="img-content">
                      <div className="title">{React.language('workbench.noticeBoard.add.img')}</div>
                      <div className="text">{React.language("form.theme.image")}</div>
                      <div className="text-tip">
                        {React.language('image.upload.rules.one', { count: window.FX.STATIC.VIP_PACK.single_file / 1024 / 1024 })}
                      </div>
                      <div className="up-div">
                        {!_.isEmpty(this.state.imgFile) && <div className={classNames("img-box", this.state.coverStyle)}
                          style={{
                            backgroundImage:"url(" + (this.state.imgFile.previewUrl ||  BsyUtils.getfiledownloadURL(this.state.imgFile, {})) + ")"
                          }}
                        ></div>}

                        <div className="add-img-content">

                          {
                            _.isEmpty(this.state.imgFile) && <form
                              className="upload-form"
                              action="/file/upload_des_img"
                              method="post"
                              multiple
                            >
                              <input
                                type="file"
                                name="file"
                                onChange={this.changeImg}
                                className="upload-btn-input"
                                accept=".jpg,.png,.jpeg,.gif"
                              />
                            </form>
                          }
                          {_.isEmpty(this.state.imgFile) && <i className="upload-icon icon-bby-add"></i>}
                          {
                            !_.isEmpty(this.state.imgFile) && <>
                              <div className="upload-box">
                                <div className="upload-btn"><i className="icon-bsy-reportmenu-7"></i></div>
                                <form
                                  className="upload-form"
                                  action="/file/upload_des_img"
                                  method="post"
                                  multiple
                                >
                                  <input
                                    type="file"
                                    name="file"
                                    onChange={this.changeImg}
                                    className="upload-btn-input"
                                    accept=".jpg,.png,.jpeg,.gif"
                                  />
                                </form>
                              </div>
                              <div className="delete-btn" onClick={this.deleteImg}><i className="icon-trasho"></i></div>
                            </>
                          }

                        </div>
                      </div>
                      <div className="title-cover">
                        {React.language("dash.image.position")}
                      </div>
                      <BsyRadioGroup layout={"horizontal"} value={this.state.coverStyle} baseCls="radio-group-sthree bsy-x-group"
                        items={[
                          {
                            value: "stretchCenter",
                            text: React.language("form.theme.imageMore.center"),
                          },
                          {
                            value: "fillInCenter",
                            text: React.language("form.theme.imageMore.centerCover"),
                          },
                          {
                            value: "masterDrawingCenter",
                            text: React.language("form.theme.imageMore.stretchCover"),
                          },
                        ]}
                        onStopEdit={(e) => {
                          this.setState({
                            coverStyle: e,
                          });
                        }}
                      />
                      <div>{React.language("dashboard.link.type")}</div>
                      <BsyRadioGroup layout={"horizontal"} value={this.state.imgLinkType} baseCls="radio-group-two bsy-x-group"
                        items={[
                          {
                            value: "internalPage",
                            text: React.language("dashboard.open.internal.page"),
                          },
                          {
                            value: "externalLink",
                            text: React.language("dashboard.open.external.link"),
                          },
                        ]}
                        onStopEdit={(e) => {
                          this.setState({
                            imgLinkType: e,
                          });
                        }}
                      />
                      {this.state.imgLinkType === "internalPage" && (
                        <div className={classNames(_.isEmpty(this.state.imgModelFromData) ? "choose-type has-up" : "choose-type has-close")} onClick={() => {
                          this.chooselinkImgType()
                        }}>
                          {/* <span>{_.isEmpty(this.state.imgModelFromData) ? "请选择表单" : this.state.imgModelFromData.name}</span> */}
                          {
                            _.isEmpty(this.state.imgModelFromData) && <span className="place-holder-title">请选择表单</span>
                          }
                          {
                            !_.isEmpty(this.state.imgModelFromData) && <div className="has-icon">
                              <span className={"parent-icon color-cover-" + this.state.imgModelFromData.appinfo.style.color} >
                                <span className={"imgbg-bby-app imgbg-bby-app-" + (this.state.imgModelFromData.appinfo.style.icon)}></span>
                              </span>
                              <span>{this.state.imgModelFromData.appinfo.appname}</span>
                              <span className="line">—</span>
                              {/* <i className={"icon-bsy-form "+this.state.titleModelFromData.appinfo.style.newIcon?"icon-new-bsy-form-"+this.state.titleModelFromData.appinfo.style.newIcon:"icon-bsy-form-"+this.state.titleModelFromData.icon}></i> */}
                              <span>{this.state.imgModelFromData.name}</span>
                            </div>
                          }
                          <i className="icon-down1"></i>
                          <i className="icon-dingding-guide-close close" onClick={this.deleteImgModelFromDataFn}></i>
                        </div>
                      )}
                      {this.state.imgLinkType === "externalLink" && (
                        <div className="input-box">
                          <input placeholder="请输入链接" className="t-input" defaultValue={this.theImgModelink}
                            onInput={(event) => {
                              this.linkImgEdit(event);
                            }}
                          ></input>
                        </div>
                      )}
                    </div>
                  </>
                }

              </>
            }
            {
              this.state.isShowSetDynamicPage && <ConfigurationBulletinConfig emitDynamicComplete={this.emitDynamicComplete} dynamicDialogObj={this.state.dynamicDialogObj}></ConfigurationBulletinConfig>
            }
            {
              this.state.isShowSetStaticPage && <BsyConfigurationBulletinStaicConfig emitStaciComplete={this.emitStaciComplete} staticData={this.staticData}></BsyConfigurationBulletinStaicConfig>
            }
          </div>
        </div>
        <div className="config-footer">
          <div className="footer-btn cancel" onClick={this.closePan}>
            <span>{React.language("cancel")}</span>
          </div>
          <div className={classNames(this.state.isSaveEvent ? "" : "on-event-box")} >
            <div className={classNames(this.state.isSaveEvent ? "footer-btn save" : "footer-btn save on-event")} onClick={this.savePan}>
              <span>{React.language("save")}</span>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default BsyDashboardNoticeBoardConfig;
